import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap, RouterModule } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { ChartEmbedComponent } from '../../_components/chart-embed/chart-embed.component';

@Component({
    selector: 'app-chart-details',
    templateUrl: './chart-details.component.html',
    styleUrls: ['./chart-details.component.scss'],
    imports:[ChartEmbedComponent,RouterModule]
})
export class ChartDetailsComponent implements OnInit {

  chartId

  constructor(private route: ActivatedRoute, private dataservice: DataServiceService, private seoservice: SeoService) {

   }

  ngOnInit() {

    this.route.params.subscribe(params => {
// $&("params", params)
      this.chartId = params.id
    })
  }

  

}
